import api from "./axiosInstance";

/**
 * Fetch WhatsApp Credits from the API
 * @returns {Promise<number>} The number of WhatsApp credits available
 */
export const getWhatsAppCredits = async () => {
  try {
    const timestamp = Date.now();
    const response = await api.get(`client-config/current/whatsapp-credits?t=${timestamp}`);
    console.log("WhatsApp Credits API response:", response.data);
    
    // The API returns a number (e.g., 9999)
    return response.data;
  } catch (error) {
    console.error("Error fetching WhatsApp credits:", error);
    throw error;
  }
};
